export const APP_INSIGHTS_APP_SERVICE = {
  // [AS] = App Service
  SW_UPDATE_CHECK_ERROR: `[AS] SW UPDATE CHECK ERROR`,
};
